export default "__VITE_ASSET__684b8365__"